import { render } from "./ConnectWithMe.vue?vue&type=template&id=f899d152&scoped=true"
import script from "./ConnectWithMe.vue?vue&type=script&lang=js"
export * from "./ConnectWithMe.vue?vue&type=script&lang=js"

import "./ConnectWithMe.vue?vue&type=style&index=0&id=f899d152&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f899d152"]])

export default __exports__